import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import VerifiedIcon from '@mui/icons-material/Verified';
import AddCardIcon from '@mui/icons-material/AddCard';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 22
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			backgroundImage: 'linear-gradient( 136deg, #2196F3 0%, #1E88E5 50%, #1565C0 100%)'
		}
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			backgroundImage: 'linear-gradient( 136deg, #2196F3 0%, #1E88E5 50%, #1565C0 100%)'
		}
	},
	[`& .${stepConnectorClasses.line}`]: {
		height: 3,
		border: 0,
		backgroundColor: '#eaeaf0',
		borderRadius: 1,
		...theme.applyStyles('dark', {
			backgroundColor: theme.palette.grey[800]
		})
	}
}));

const ColorlibStepIconRoot = styled('div')<{
	ownerState: { completed?: boolean; active?: boolean };
}>(({ theme }) => ({
	backgroundColor: '#ccc',
	zIndex: 1,
	color: '#fff',
	width: 50,
	height: 50,
	display: 'flex',
	borderRadius: '50%',
	justifyContent: 'center',
	alignItems: 'center',
	...theme.applyStyles('dark', {
		backgroundColor: theme.palette.grey[700]
	}),
	variants: [
		{
			props: ({ ownerState }) => ownerState.active,
			style: {
				backgroundImage: 'linear-gradient( 136deg, #2196F3 0%, #1E88E5 50%, #1565C0 100%)',
				boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
			}
		},
		{
			props: ({ ownerState }) => ownerState.completed,
			style: {
				backgroundImage: 'linear-gradient( 136deg, #2196F3 0%, #1E88E5 50%, #1565C0 100%)'
			}
		}
	]
}));

function ColorlibStepIcon(props: StepIconProps & { stepLabel?: string }) {
	const { active, completed, className, icon, stepLabel } = props;

	// Map icons by step label so the correct icon renders regardless of position.
	const iconByLabel: Record<string, React.ReactElement> = {
		'Sign Up': <SettingsIcon />,
		Confirm: <GroupAddIcon />,
		MFA: <QrCode2Icon />,
		Profile: <AccountCircleIcon />,
		Plan: <AddCardIcon />
	};

	// Fall back to position-based lookup for backwards compatibility.
	const iconsByIndex: { [index: string]: React.ReactElement } = {
		1: <SettingsIcon />,
		2: <GroupAddIcon />,
		3: <QrCode2Icon />,
		4: <AccountCircleIcon />,
		5: <AddCardIcon />
	};

	const resolvedIcon = (stepLabel && iconByLabel[stepLabel]) || iconsByIndex[String(icon)] || <Check />;

	return (
		<ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
			{resolvedIcon}
		</ColorlibStepIconRoot>
	);
}

type CustomStepperProps = {
	steps: string[];
	activeStep: number;
	className?: string;
	sx?: any;
};
const CustomStepper: React.FC<CustomStepperProps> = ({ steps, activeStep, className, sx }) => {
	return (
		<Stack sx={{ width: '100%', ...sx }} spacing={4} className={className}>
			<Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel StepIconComponent={(props) => <ColorlibStepIcon {...props} stepLabel={label} />}>
							{label}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</Stack>
	);
};

export default CustomStepper;
